import { render } from "./productH.vue?vue&type=template&id=74b7a169&scoped=true"
import script from "./productH.vue?vue&type=script&lang=js"
export * from "./productH.vue?vue&type=script&lang=js"

import "./productH.vue?vue&type=style&index=0&id=74b7a169&scoped=true&lang=less"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b7a169"]])

export default __exports__